// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"build_node_index_js":"4e261f84710b59eec5e0a04dcfcbf7d4153641b20321a28d8274edac9ae2f32c","node_modules_react_index_js":"7d7485f470234010ac1ac35604536f8ddc0956bd2335506d15e1168db6893246"}[chunkId] + ".js";
};